/**
 * Panneau Sources — EX-15
 * Affiche: chunks (document/section/page), relations graphe, traces raisonnement
 */
import React, { useState } from "react";

export default function SourcePanel({ sources, queryMode, fallbackUsed, groundingScore }) {
  const [expanded, setExpanded] = useState(false);

  const chunks = sources.filter((s) => s.type === "chunk");
  const relations = sources.filter((s) => s.type === "relation");
  const communities = sources.filter((s) => s.type === "community");

  if (!sources.length) return null;

  return (
    <div className="source-panel">
      <div className="source-panel__header" onClick={() => setExpanded(!expanded)}>
        <span>📚 {sources.length} source(s)</span>
        <span className="query-mode-badge">{queryMode}</span>
        {fallbackUsed && <span className="fallback-badge">↩ fallback</span>}
        {groundingScore != null && (
          <span className={`grounding-badge ${groundingScore >= 0.7 ? "ok" : "warn"}`}>
            ancrage {Math.round(groundingScore * 100)}%
          </span>
        )}
        <span>{expanded ? "▲" : "▼"}</span>
      </div>

      {expanded && (
        <div className="source-panel__body">
          {/* Chunks documentaires */}
          {chunks.length > 0 && (
            <section>
              <h4>Extraits documentaires</h4>
              {chunks.map((s, i) => (
                <div key={i} className="source-chunk">
                  <div className="source-chunk__meta">
                    <span className="doc-name">{_shortPath(s.document)}</span>
                    {s.section && <span className="section">{s.section}</span>}
                    {s.page_range?.start && (
                      <span className="page">p.{s.page_range.start}
                        {s.page_range.end !== s.page_range.start && `–${s.page_range.end}`}
                      </span>
                    )}
                    {s.score && <span className="score">{(s.score * 100).toFixed(0)}%</span>}
                  </div>
                  <p className="source-chunk__text">{s.text}</p>
                  {s.description && (
                    <p className="source-chunk__desc">💡 {s.description}</p>
                  )}
                </div>
              ))}
            </section>
          )}

          {/* Relations du graphe (EX-15) */}
          {relations.length > 0 && (
            <section>
              <h4>Relations du graphe</h4>
              <ul className="relation-list">
                {relations.map((r, i) => (
                  <li key={i} className="relation-item">{r.text}</li>
                ))}
              </ul>
            </section>
          )}

          {/* Communautés */}
          {communities.length > 0 && (
            <section>
              <h4>Thèmes transversaux</h4>
              {communities.map((c, i) => (
                <div key={i} className="community-item">
                  <p>{c.text}</p>
                  {c.entity_count && <small>{c.entity_count} entités</small>}
                </div>
              ))}
            </section>
          )}
        </div>
      )}
    </div>
  );
}

function _shortPath(uri) {
  if (!uri) return "Document";
  const parts = uri.split(/[/\\]/);
  return parts[parts.length - 1] || uri;
}
